<template>
  <div class="formOuter">
    <form @submit.prevent="submitForm">
      <div class="form-control" :class="{ invalid: !name.isValid }">
        <label for="name">Project Name</label>
        <input
          type="text"
          id="name"
          v-model.trim="name.val"
          @blur="clearValidity('name')"
        />
        <span v-if="!name.isValid">Project Name Required</span>
      </div>
      <div class="form-control" :class="{ invalid: !description.isValid }">
        <label for="description">Project Description</label>
        <textarea
          id="description"
          rows="5"
          v-model.trim="description.val"
          @blur="clearValidity('description')"
        ></textarea>
        <span v-if="!description.isValid">Project description Required</span>
      </div>
      <div class="form-control-group" :class="{ invalid: !type.isValid }">
        <h3>Project Type</h3>
        <div class="form-control">
          <input
            type="checkbox"
            id="web"
            value="web"
            v-model="type.val"
            @blur="clearValidity('type')"
          />
          <label for="web">Website</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="android"
            value="android"
            v-model="type.val"
            @blur="clearValidity('type')"
          />
          <label for="android">Android</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="ios"
            value="ios"
            v-model="type.val"
            @blur="clearValidity('type')"
          />
          <label for="ios">iOS</label>
        </div>
        <span v-if="!type.isValid">Check Atleast one type</span>
      </div>
      <div class="form-control" :class="{ invalid: !date.isValid }">
        <label for="date">Date</label>
        <input
          type="date"
          id="date"
          v-model="date.val"
          @blur="clearValidity('date')"
        />
        <span v-if="!date.isValid">Project Date Required</span>
      </div>
      <div class="form-control-group" :class="{ invalid: !mode.isValid }">
        <h3>Mode</h3>
        <div class="form-control">
          <input
            type="radio"
            id="start"
            value="start"
            v-model="mode.val"
            @blur="clearValidity('mode')"
          />
          <label for="start">Start</label>
        </div>
        <div class="form-control">
          <input
            type="radio"
            id="hold"
            value="hold"
            v-model="mode.val"
            @blur="clearValidity('mode')"
          />
          <label for="hold">Hold</label>
        </div>
        <div class="form-control">
          <input
            type="radio"
            id="finish"
            value="finish"
            v-model="mode.val"
            @blur="clearValidity('mode')"
          />
          <label for="finish">Complete</label>
        </div>
        <span v-if="!mode.isValid">Check Atleast one Mode</span>
      </div>
      <span v-if="!formIsValid"
        >Form Is Invalid Please fill all information again.</span
      >
      <base-button>Add Project</base-button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formIsValid: true,
      isLoading:false,
      error:null,
      name: {
        val: "",
        isValid: true,
      },
      description: {
        val: "",
        isValid: true,
      },
      type: {
        val: [],
        isValid: true,
      },
      date: {
        val: "",
        isValid: true,
      },
      mode: {
        val: [],
        isValid: true,
      },
    };
  },
  methods: {
    validateForm() {
      this.formIsValid = true;
      if (this.name.val === "") {
        this.name.isValid = false;
        this.formIsValid = false;
      }
      if (this.description.val === "") {
        this.description.isValid = false;
        this.formIsValid = false;
      }
      if (this.date.val === "") {
        this.date.isValid = false;
        this.formIsValid = false;
      }
      if (this.type.val.length === 0) {
        this.type.isValid = false;
        this.formIsValid = false;
      }
      if (this.mode.val.length === 0) {
        this.mode.isValid = false;
        this.formIsValid = false;
      }
    },
    submitForm() {
      this.validateForm();
      if (!this.formIsValid) {
        return;
      }
      const formData = {
        projectName: this.name.val,
        desc: this.description.val,
        projectType: this.type.val,
        date: this.date.val,
        projectMode: this.mode.val,
      };
      this.isLoading=true;
      try{
        this.$store.dispatch("projects/addProject", formData);
      }catch(err){
        this.error = (err.message)
      }
      this.$router.replace("/home");
    },
    clearValidity(input) {
      this[input].isValid = true;
      this.formIsValid = true;
    },
  },
};
</script>

<style scoped>
.formOuter {
  padding: 1vw;
  box-sizing: border-box;
}
.formOuter span {
  color: red;
  margin-top: 5px;
}
.form-control {
  width: 100%;
  margin-bottom: 20px;
  text-align: left;
}
.form-control label {
  margin-bottom: 8px;
  width: 100%;
}
.form-control input[type="text"],
.form-control input[type="date"],
.form-control textarea {
  width: 100%;
  border: 1px solid #c1c1c1;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
}

.form-control-group {
  text-align: left;
}
.form-control-group h3 {
  text-align: left;
}
.invalid input,
.invalid textarea {
  border-color: red !important;
}
.invalid span {
  color: red;
  text-align: left;
}
.invalid h3 {
  color: red !important;
}
</style>
